<template>
    <div>
        <div v-if="loading" class="d-flex justify-content-center">
            <b-spinner />
        </div>

        <ErrorMessage :value="error" />

        <template v-if="plugin && !error">
            <PluginCode :plugin="plugin" />
            <PluginCampaignsList ref="campaignsList" class="mb-5" :plugin="plugin" />
            <PluginExtension ref="extensions" class="mb-5" :plugin="plugin" />
            <PluginAppearance ref="appearance" class="mb-5" :plugin="plugin" />
        </template>
    </div>
</template>

<script>
    import ErrorMessage from '@/components/common/ErrorMessage.vue';
    import PluginCampaignsList from './parts/PluginCampaignsList.vue';
    import PluginAppearance from './parts/PluginAppearance.vue';
    import PluginCode from './parts/PluginCode.vue';
    import PluginExtension from './parts/PluginExtension.vue';

    export default {
        name: 'PluginView',
        components: {
            PluginCampaignsList,
            PluginAppearance,
            PluginCode,
            PluginExtension,
            ErrorMessage,
        },
        data() {
            return {
                spaceInitialized: false,
                error: null,
                pluginsRequest: this.$req('plugin/producerPlugin'),
            };
        },
        computed: {
            loading() {
                return this.pluginsRequest.getLoading();
            },
            space() {
                return this.$store.getters['space/currentSpace'];
            },
            plugin() {
                return this.pluginsRequest.getData();
            },
        },

        watch: {
            space: {
                immediate: true,
                handler() {
                    this.handleSpaceChange();
                },
            },
        },
        methods: {
            async handleSpaceChange() {
                if (!this.spaceInitialized) this.spaceInitialized = true;
                await this.getPlugins();
            },
            async getPlugins() {
                try {
                    this.error = null;

                    await this.pluginsRequest.get(this.space.id);

                    if (this.plugin) {
                        this.$refs.campaignsList?.getData?.();
                        await this.$refs.extensions?.loadList?.();
                    }
                } catch (err) {
                    this.error = err;
                }
            },
        },
    };
</script>
